import request from "@/utils/request";
export function navbar(data) {
    return request({
        url: '/api/portal/v1/portal/selectPortalColumnTreeInfo',
        method: 'post',
        data
    })
}